import { h, render } from 'preact';
import { PaymentAlert } from './PaymentAlert/PaymentAlert';
import { BannersConfig } from './types';
import styles from './PaymentAlert/PaymentAlert.css?inline';
import { FRICTIONLESS_PAYMENT_PATH } from './PaymentAlert/constants';

const sheet = new CSSStyleSheet();
sheet.replaceSync(styles);

class OgPaymentAlert extends HTMLElement {
  static config: BannersConfig;
  private shadow: ShadowRoot;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadow.adoptedStyleSheets = [sheet];
    render(h(PaymentAlert, { config: OgPaymentAlert.config }), this.shadow);
  }

  disconnectedCallback() {
    render(null, this.shadow);
  }
}

export function initialize(config: BannersConfig): void {
  OgPaymentAlert.config = config;
  if (!customElements.get('og-payment-alert')) {
    customElements.define('og-payment-alert', OgPaymentAlert);
  }
  if (!document.querySelector('og-payment-alert') && !window.location.pathname.includes(FRICTIONLESS_PAYMENT_PATH)) {
    document.body.prepend(document.createElement('og-payment-alert'));
  }
}

window.og = window.og || {};
window.og.banners = window.og.banners || { initialize };
